export default __webpack_public_path__ + "media/images/vorwort-cocktailglas-948b4ce438443a881214718b0f6238cb.jpg";